import type { CSSProperties, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { IconArt } from '@/components/generals/icon-art'
import { Tilt } from '@/components/generals/tilt'
import { Scallop } from '@/components/generals/scallop'
import { SectionHeading } from '@/components/generals/section-heading'
import { BENEFITS } from '@/constants/home'

export const Benefits: FC = (): ReactNode => {
    return (
        <section id='why-us' aria-labelledby='why-us-title' className='on-dark relative bg-plum-deep py-24 text-cream sm:py-32'>
            <Scallop className='text-plum-deep' />

            <div className='mx-auto max-w-6xl px-5 sm:px-8'>
                <SectionHeading
                    id='why-us-title'
                    lines={['Why clients', 'keep coming back']}
                    sticker='The good stuff'
                    stickerShape='cloud'
                    stickerColor='text-butter'
                    stickerClassName='sm:size-28'
                />

                <ul className='mt-16 grid gap-5 md:grid-cols-2 lg:grid-cols-3'>
                    {BENEFITS.map((benefit, index) => (
                        <li
                            key={benefit.title}
                            className={cn('reveal', benefit.wide && 'lg:col-span-2', index === 0 && 'md:col-span-2')}
                            style={{ '--reveal-delay': `${(index % 3) * 120}ms` } as CSSProperties}
                        >
                            <Tilt
                                className={cn(
                                    'group flex h-full flex-col gap-6 rounded-[2rem] border-2 border-transparent p-7 text-plum transition-[border-color,box-shadow] duration-300 hover:border-plum hover:shadow-[0_8px_0_0_var(--color-butter)] sm:p-8',
                                    benefit.color,
                                    benefit.wide && 'lg:flex-row lg:items-center lg:justify-between'
                                )}
                            >
                            <IconArt
                                icon={benefit.icon}
                                shape={benefit.shape}
                                colorClassName='text-cream'
                                accentClassName={benefit.accent}
                                tilt={index % 2 === 0 ? 'left' : 'right'}
                                className={cn('size-32', benefit.wide && 'lg:order-2 lg:size-40')}
                            />

                            <div className={cn(benefit.wide && 'lg:max-w-md')}>
                                <h3 className='font-heading text-[clamp(1.75rem,3vw,2.4rem)] leading-none'>
                                    {benefit.title}
                                </h3>

                                <p className='mt-3 leading-relaxed text-plum/80'>
                                    {benefit.text}
                                </p>
                            </div>
                            </Tilt>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}
